<form
  class="contact-info"
  [formGroup]="contactForm"
  (ngSubmit)="formSubmitted.emit()"
  submitOnEnter
>
  @if (inputList().includes('names')) {
    @for (control of [contactForm.controls.lastName, contactForm.controls.firstName, contactForm.controls.middleName]; track control) {
      @let labelText = getLabelText(control);
      <div
        class="form__control-container contact-info-control"
        [class.field--invalid]="isControlInvalid(control)"
      >
        <label
          class="form__label"
          [for]="labelText"
        >
          {{ labelText | translate }}
        </label>

        <div class="form__control">
          <input
            class="form__input"
            [formControl]="control"
            type="text"
            [id]="labelText"
            inputCapitalize
          >

          @if (isControlInvalid(control)) {
            <div class="form__input-error">
              {{ 'global.required_field' | translate }}
            </div>
          }
        </div>
      </div>
    }
  }

  @if (inputList().includes('phone')) {
    <div
      class="form__control-container contact-info-control"
      [class.field--invalid]="isControlInvalid(contactForm.controls.phoneNumber)"
    >
      <label
        class="form__label"
        for="addr-phone"
      >
        {{ 'address_form.phone' | translate }}
      </label>

      <div class="form__control">
        <input
          class="form__input"
          [formControl]="contactForm.controls.phoneNumber"
          [mask]="PHONE_NUMBER_MASK"
          inputmode="tel"
          type="text"
          id="addr-phone"
        >

        @if (isControlInvalid(contactForm.controls.phoneNumber)) {
          <div class="form__input-error">
            {{ 'global.required_field' | translate }}
          </div>
        }
      </div>
    </div>
  }
</form>
